/* InLei® Schulungsfinder — Ablauf, Entfernung, vorbefüllte Nachricht.

   Liegt als eigene Datei vor, nicht als Inline-Skript in der Section:
   dieselbe Trennung wie bei assets/inlei-leiste.js.

   Die Entfernung wird im Browser gerechnet, ohne dass die Postleitzahl
   das Gerät verlässt — kein Geocoding-Dienst, keine Anfrage an Dritte.
   Grundlage ist die Tabelle in assets/inlei-plz-de.js (alle deutschen
   Postleitzahlen, rund ein Kilometer genau), die erst beim Öffnen des
   Panels nachgeladen wird. Für Österreich und die Schweiz gibt es nur
   eine grobe Tabelle nach der ersten Ziffer; dort sitzen drei Trainer,
   die Reihenfolge stimmt trotzdem. */
(() => {
  'use strict';

  /* --- Leitregionen: erste zwei Ziffern der deutschen PLZ auf einen
     Mittelpunkt der Region. Fehlende Nummern (00, 05, 43, 62) gibt es
     in Deutschland nicht. --- */
  const DE = {
    '01': [51.05, 13.74], '02': [51.18, 14.43], '03': [51.76, 14.33], '04': [51.34, 12.37],
    '06': [51.48, 11.97], '07': [50.88, 12.08], '08': [50.72, 12.49], '09': [50.83, 12.92],
    '10': [52.52, 13.40], '11': [52.52, 13.40], '12': [52.46, 13.42], '13': [52.56, 13.35],
    '14': [52.40, 13.06], '15': [52.35, 14.55], '16': [52.83, 13.82], '17': [53.56, 13.26],
    '18': [54.09, 12.14], '19': [53.63, 11.41], '20': [53.55, 9.99], '21': [53.25, 10.41],
    '22': [53.60, 10.05], '23': [53.87, 10.69], '24': [54.32, 10.14], '25': [53.93, 9.52],
    '26': [53.14, 8.21], '27': [53.54, 8.58], '28': [53.08, 8.81], '29': [52.62, 10.08],
    '30': [52.37, 9.73], '31': [52.15, 9.95], '32': [52.12, 8.67], '33': [51.83, 8.65],
    '34': [51.31, 9.49], '35': [50.58, 8.68], '36': [50.55, 9.68], '37': [51.53, 9.93],
    '38': [52.27, 10.52], '39': [52.13, 11.62], '40': [51.23, 6.78], '41': [51.19, 6.44],
    '42': [51.26, 7.15], '44': [51.51, 7.47], '45': [51.46, 7.01], '46': [51.50, 6.85],
    '47': [51.43, 6.76], '48': [51.96, 7.63], '49': [52.28, 8.05], '50': [50.94, 6.96],
    '51': [51.03, 7.02], '52': [50.78, 6.08], '53': [50.73, 7.10], '54': [49.75, 6.64],
    '55': [50.00, 8.27], '56': [50.36, 7.59], '57': [50.87, 8.02], '58': [51.36, 7.47],
    '59': [51.68, 7.82], '60': [50.11, 8.68], '61': [50.23, 8.62], '63': [50.10, 8.90],
    '64': [49.87, 8.65], '65': [50.08, 8.24], '66': [49.24, 6.99], '67': [49.44, 8.10],
    '68': [49.49, 8.47], '69': [49.40, 8.69], '70': [48.78, 9.18], '71': [48.80, 9.05],
    '72': [48.52, 9.06], '73': [48.70, 9.65], '74': [49.14, 9.22], '75': [48.89, 8.70],
    '76': [49.01, 8.40], '77': [48.47, 7.94], '78': [48.06, 8.46], '79': [47.99, 7.85],
    '80': [48.14, 11.58], '81': [48.11, 11.62], '82': [47.99, 11.35], '83': [47.86, 12.12],
    '84': [48.54, 12.15], '85': [48.40, 11.75], '86': [48.37, 10.90], '87': [47.73, 10.31],
    '88': [47.78, 9.61], '89': [48.40, 9.99], '90': [49.45, 11.08], '91': [49.59, 10.99],
    '92': [49.44, 11.86], '93': [49.02, 12.10], '94': [48.57, 13.46], '95': [49.95, 11.58],
    '96': [49.89, 10.89], '97': [49.79, 9.94], '98': [50.61, 10.69], '99': [50.98, 11.03]
  };

  /* Österreich und Schweiz haben vierstellige PLZ; hier genügt die erste
     Ziffer (Bundesland bzw. Grossregion), weil dort nur drei Trainer
     sitzen. Die Schätzung ist gröber — die Ausgabe sagt das mit "ca.". */
  const AT = {
    '1': [48.21, 16.37], '2': [48.15, 16.45], '3': [48.20, 15.62], '4': [48.31, 14.29],
    '5': [47.81, 13.04], '6': [47.27, 11.39], '7': [47.85, 16.52], '8': [47.07, 15.44],
    '9': [46.62, 14.31]
  };

  const CH = {
    '1': [46.52, 6.63], '2': [47.00, 6.93], '3': [46.95, 7.45], '4': [47.56, 7.59],
    '5': [47.39, 8.05], '6': [47.05, 8.31], '7': [46.85, 9.53], '8': [47.37, 8.54],
    '9': [47.42, 9.37]
  };

  /* Genaue Suche in der nachgeladenen Tabelle: 8298 Einträge zu je neun
     Zeichen, nach Postleitzahl sortiert — deshalb binäre Suche direkt auf
     dem Text, ohne ihn vorher zu zerlegen. Fehlt die Tabelle (Netzfehler),
     greift die grobe Leitregionen-Tabelle oben. */
  function ausTabelle(plz) {
    const s = window.INLEI_PLZ_DE;
    if (!s || s.length % 9 !== 0) return null;
    let lo = 0;
    let hi = s.length / 9 - 1;
    while (lo <= hi) {
      const m = (lo + hi) >> 1;
      const k = s.substr(m * 9, 5);
      if (k < plz) lo = m + 1;
      else if (k > plz) hi = m - 1;
      else {
        return [
          parseInt(s.substr(m * 9 + 5, 2), 36) / 100 + 47,
          parseInt(s.substr(m * 9 + 7, 2), 36) / 100 + 5
        ];
      }
    }
    return null;
  }

  function ortAusPlz(land, plz) {
    const ziffern = String(plz || '').replace(/\D/g, '');
    if (land === 'DE') {
      if (ziffern.length !== 5) return null;
      return ausTabelle(ziffern) || DE[ziffern.slice(0, 2)] || null;
    }
    if (ziffern.length !== 4) return null;
    return (land === 'AT' ? AT : CH)[ziffern.slice(0, 1)] || null;
  }

  /* Die Tabelle wiegt rund 70 KB und wird deshalb erst geholt, wenn jemand
     den Finder wirklich öffnet — nicht schon beim Seitenaufruf. */
  let tabelleLaeuft = null;
  function tabelleLaden(quelle) {
    if (window.INLEI_PLZ_DE || !quelle) return Promise.resolve();
    if (tabelleLaeuft) return tabelleLaeuft;
    tabelleLaeuft = new Promise((fertig) => {
      const el = document.createElement('script');
      el.src = quelle;
      el.onload = () => fertig();
      el.onerror = () => fertig();
      document.head.appendChild(el);
    });
    return tabelleLaeuft;
  }

  function entfernung(a, b) {
    const R = 6371;
    const rad = (g) => (g * Math.PI) / 180;
    const dLat = rad(b[0] - a[0]);
    const dLon = rad(b[1] - a[1]);
    const h =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  /* Die Tabelle trifft auf etwa einen Kilometer genau, deshalb darf die
     Angabe unter 10 km auf den Kilometer genau sein; darüber wird gerundet,
     weil die Luftlinie ohnehin nicht die Fahrstrecke ist. */
  function gerundet(km) {
    if (km < 3) return 'in deinem Ort';
    if (km < 10) return 'ca. ' + Math.round(km) + ' km entfernt';
    return 'ca. ' + Math.round(km / 5) * 5 + ' km entfernt';
  }

  const BEREICH_TEXT = {
    lashfiller: 'Wimpernlifting (Lash Filler)',
    browbomber: 'Augenbrauenlifting (Brow Bomber)',
    beides: 'beides — Lash Filler und Brow Bomber',
    perfektion: 'Perfektionstraining, um die Technik zu verfeinern'
  };
  const ERFAHRUNG_TEXT = {
    einsteiger: 'Einsteigerin, noch keine Lifting-Erfahrung',
    profi: 'bereits Kosmetikerin mit Erfahrung'
  };
  const KURS_TEXT = {
    lashfiller: 'Wimpernlifting (Lash Filler)',
    browbomber: 'Augenbrauenlifting (Brow Bomber)',
    perfektion: 'Perfektionstraining'
  };
  const ZEITRAUM_TEXT = {
    sofort: 'so schnell wie möglich',
    quartal: 'in den nächsten 1–3 Monaten',
    flexibel: 'zeitlich flexibel'
  };

  /* Preise sind immer Preise JE Schulung. Wer "beides" waehlt, bucht zwei
     eigenstaendige Tagesschulungen und zahlt zweimal — darauf bekommt er den
     Kombi-Rabatt. Genau diese Unterscheidung fehlte im Finder und hat zu
     Anfragen gefuehrt, in denen 500 EUR fuer beide Schulungen zusammen
     erwartet wurden. */
  function euro(betrag) {
    const nachkomma = Math.round(betrag * 100) % 100 === 0 ? 0 : 2;
    return (
      betrag.toLocaleString('de-DE', {
        minimumFractionDigits: nachkomma,
        maximumFractionDigits: nachkomma
      }) + ' €'
    );
  }

  function rechnung(antwort, preise) {
    if (antwort.bereich === 'perfektion') {
      return {
        posten: [{ text: KURS_TEXT.perfektion + ', ohne Starterset', betrag: preise.perfektion }],
        rabatt: 0,
        gesamt: preise.perfektion,
        kurz: euro(preise.perfektion) + ' (Perfektionstraining, ohne Starterset)'
      };
    }

    const mitSet = antwort.set !== 'ohne';
    const einzel = mitSet ? preise.mit : preise.ohne;
    const zusatz = mitSet ? ' inkl. großem Starterset' : ' ohne Starterset';
    const kurse =
      antwort.bereich === 'beides'
        ? ['lashfiller', 'browbomber']
        : [antwort.bereich || 'lashfiller'];

    const posten = kurse.map((k) => ({
      text: KURS_TEXT[k] + ' — 8-Stunden-Tagesschulung' + zusatz,
      betrag: einzel
    }));
    const summe = einzel * kurse.length;
    // Nur auf die Kombination aus beiden Schulungen, nie auf eine einzelne.
    const rabatt =
      kurse.length > 1 && preise.rabatt > 0
        ? Math.round(summe * preise.rabatt) / 100
        : 0;
    const gesamt = Math.round((summe - rabatt) * 100) / 100;

    const kurz =
      kurse.length > 1
        ? kurse.length + ' × ' + euro(einzel) + zusatz + ' = ' + euro(summe) +
          (rabatt > 0
            ? ', abzüglich ' + preise.rabatt + ' % Kombi-Rabatt (−' + euro(rabatt) + ') = ' + euro(gesamt)
            : '')
        : euro(einzel) + zusatz;

    return { posten: posten, rabatt: rabatt, gesamt: gesamt, kurz: kurz, einzel: einzel, anzahl: kurse.length };
  }

  const init = (wurzel) => {
    const finder = (wurzel || document).querySelector('[data-finder]');
    if (!finder || finder.dataset.finderBereit === 'true') return;
    finder.dataset.finderBereit = 'true';

    const datenFeld = finder.querySelector('[data-finder-trainer]');
    let trainer = [];
    try {
      trainer = JSON.parse(datenFeld.textContent) || [];
    } catch (e) {
      trainer = [];
    }

    const schritte = Array.from(finder.querySelectorAll('[data-finder-schritt]'));
    const balken = finder.querySelector('[data-finder-balken]');
    const zaehler = finder.querySelector('[data-finder-zaehler]');
    const zurueck = finder.querySelector('[data-finder-zurueck]');
    const plzFeld = finder.querySelector('[data-finder-plz]');
    const landFeld = finder.querySelector('[data-finder-land]');
    const plzFehler = finder.querySelector('[data-finder-plz-fehler]');
    const liste = finder.querySelector('[data-finder-liste]');
    const nameFeld = finder.querySelector('[data-finder-name]');
    const mailFeld = finder.querySelector('[data-finder-mail]');
    const telFeld = finder.querySelector('[data-finder-telefon]');
    const kontaktFehler = finder.querySelector('[data-finder-kontakt-fehler]');
    const hinweisFeld = finder.querySelector('[data-finder-hinweis]');

    const zahl = (wert, ersatz) => {
      const n = parseFloat(String(wert).replace(',', '.'));
      return isFinite(n) ? n : ersatz;
    };
    const preise = {
      mit: zahl(finder.dataset.preisMit, 500),
      ohne: zahl(finder.dataset.preisOhne, 399),
      perfektion: zahl(finder.dataset.preisPerfektion, 399),
      rabatt: zahl(finder.dataset.kombiRabatt, 0)
    };

    const antwort = {
      bereich: '', erfahrung: '', land: 'DE', plz: '', set: '', zeitraum: '',
      name: '', mail: '', telefon: '', hinweis: ''
    };
    let verlauf = [];
    let aktuell = 'bereich';
    let gewaehlterTrainer = null;
    let sortiert = [];
    let letzterOeffner = null;

    const fragen = schritte.filter((s) => s.dataset.finderSchritt !== 'ergebnis');

    /* Schritt "Starterset": Der Preis haengt daran, ob eine oder zwei
       Schulungen angefragt werden. Steht die Zahl nicht an der Option,
       liest man "Schulung 500 €" und rechnet fuer beide zusammen. */
    /* Saetze, die nur bei zwei Schulungen stimmen (Kombi-Rabatt, zweites
       Starterset). Auf dem Einzelweg bleiben sie aus — der Rabatt soll dort
       gar nicht erst auftauchen. */
    function kombiSaetzeZeigen() {
      const beides = antwort.bereich === 'beides' && preise.rabatt > 0;
      finder.querySelectorAll('[data-finder-kombi]').forEach((el) => {
        el.hidden = !beides;
      });
    }

    function setpreiseZeichnen() {
      const beides = antwort.bereich === 'beides';
      kombiSaetzeZeigen();
      const titel = finder.querySelector('[data-finder-set-titel]');
      const lead = finder.querySelector('[data-finder-set-lead]');
      if (titel) titel.textContent = beides ? 'Startersets zu deinen zwei Schulungen?' : 'Mit oder ohne Starterset?';
      if (lead) {
        lead.textContent = beides
          ? 'Du buchst zwei eigenständige Tagesschulungen. Das Starterset gibt es je Schulung — die Wahl gilt für beide.'
          : 'Das Starterset enthält alles, was du für deine ersten Behandlungen brauchst.';
      }
      ['mit', 'ohne'].forEach((variante) => {
        const feld = finder.querySelector('[data-finder-setpreis="' + variante + '"]');
        if (!feld) return;
        const r = rechnung({ bereich: antwort.bereich, set: variante }, preise);
        if (!beides) {
          feld.textContent = euro(r.einzel) + ' je Schulung';
          return;
        }
        feld.textContent =
          '2 × ' + euro(r.einzel) + ' = ' + euro(r.einzel * 2) +
          (r.rabatt > 0 ? ' · mit ' + preise.rabatt + ' % Kombi-Rabatt ' + euro(r.gesamt) : '');
      });
    }

    function preisblockZeichnen() {
      const feld = finder.querySelector('[data-finder-preis]');
      const block = finder.querySelector('[data-finder-preisblock]');
      if (!feld || !block) return;
      if (!antwort.bereich) {
        block.hidden = true;
        return;
      }
      block.hidden = false;
      kombiSaetzeZeigen();
      const r = rechnung(antwort, preise);
      const titel = finder.querySelector('[data-finder-preis-titel]');
      if (titel) titel.textContent = r.posten.length > 1 ? 'Was deine Schulungen kosten' : 'Was deine Schulung kostet';
      const zeilen = r.posten.map(
        (posten) =>
          '<li><span>' + posten.text + '</span><em>' + euro(posten.betrag) + '</em></li>'
      );
      if (r.rabatt > 0) {
        zeilen.push(
          '<li class="inlei-finder__preis-rabatt"><span>' + preise.rabatt +
            ' % Kombi-Rabatt auf beide Schulungen</span><em>−' + euro(r.rabatt) + '</em></li>'
        );
      }
      zeilen.push(
        '<li class="inlei-finder__preis-summe"><span>' +
          (r.posten.length > 1 ? 'Gesamt für beide Schulungen' : 'Gesamt') +
          '</span><em>' + euro(r.gesamt) + '</em></li>'
      );
      feld.innerHTML = '<ul>' + zeilen.join('') + '</ul>';
    }

    function zeige(name) {
      aktuell = name;
      if (name === 'set') setpreiseZeichnen();
      schritte.forEach((s) => s.classList.toggle('is-aktiv', s.dataset.finderSchritt === name));
      // Der Weg zum Perfektionstraining laesst zwei Fragen aus, deshalb
      // zaehlt die Anzeige nur die Schritte, die wirklich kommen.
      const weg =
        antwort.bereich === 'perfektion'
          ? ['bereich', 'plz', 'zeitraum', 'kontakt']
          : fragen.map((s) => s.dataset.finderSchritt);
      const nr = weg.indexOf(name);
      const gesamt = weg.length;
      if (name === 'ergebnis') {
        zaehler.textContent = 'Dein Ergebnis';
        balken.style.width = '100%';
      } else {
        zaehler.textContent = 'Schritt ' + (nr + 1) + ' von ' + gesamt;
        balken.style.width = ((nr + 1) / gesamt) * 100 + '%';
      }
      zurueck.hidden = verlauf.length === 0;
      const feld = finder.querySelector('[data-finder-schritt="' + name + '"]');
      const ziel = feld && feld.querySelector('input, button');
      if (ziel) {
        try {
          ziel.focus({ preventScroll: true });
        } catch (e) {
          /* aeltere Browser */
        }
      }
      finder.querySelector('.inlei-finder__inhalt').scrollTop = 0;
    }

    function weiter(name) {
      verlauf.push(aktuell);
      zeige(name);
    }

    function passendeTrainer() {
      const b = antwort.bereich;
      return trainer.filter((t) => {
        // Das Perfektionstraining laeuft ueber jeden Trainer, deshalb hier
        // keine Einschraenkung nach Schulungsart.
        if (b === 'perfektion') return true;
        if (b === 'beides') return t.angebot === 'beides';
        if (b === 'lashfiller') return t.angebot === 'beides' || t.angebot === 'lashfiller';
        if (b === 'browbomber') return t.angebot === 'beides' || t.angebot === 'browbomber';
        return true;
      });
    }

    function ergebnisBauen() {
      // Beim Perfektionstraining gibt es kein Starterset zur Wahl.
      const setBlock = finder.querySelector('[data-finder-setblock]');
      if (setBlock) setBlock.hidden = antwort.set === 'entfaellt';
      preisblockZeichnen();

      const ort = ortAusPlz(antwort.land, antwort.plz);
      const kandidaten = passendeTrainer().map((t) => {
        const km = ort && t.lat && t.lon ? entfernung(ort, [t.lat, t.lon]) : null;
        return Object.assign({}, t, { km: km });
      });
      kandidaten.sort((a, b) => {
        if (a.km === null) return 1;
        if (b.km === null) return -1;
        return a.km - b.km;
      });
      sortiert = kandidaten;
      trefferZeigen(kandidaten[0] || null);

      liste.innerHTML = '';
      kandidaten.slice(1).forEach((t) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.innerHTML =
          '<span><strong>' + t.name + '</strong><br>' + t.ort + '</span>' +
          '<em>' + (t.km === null ? '' : gerundet(t.km)) + '</em>';
        btn.addEventListener('click', () => {
          trefferZeigen(t);
          liste.hidden = true;
          const mehr = finder.querySelector('[data-finder-mehr]');
          if (mehr) mehr.setAttribute('aria-expanded', 'false');
        });
        li.appendChild(btn);
        liste.appendChild(li);
      });
    }

    function trefferZeigen(t) {
      gewaehlterTrainer = t;
      const kasten = finder.querySelector('[data-finder-treffer]');
      if (!t) {
        kasten.innerHTML = '<div class="inlei-finder__treffer-text"><strong>Kein Treffer</strong>' +
          '<span>Schreib uns kurz — wir finden trotzdem einen Weg.</span></div>';
        return;
      }
      const bild = t.bild
        ? '<img src="' + t.bild + '" alt="" loading="lazy" width="64" height="64">'
        : '';
      kasten.innerHTML =
        bild +
        '<div class="inlei-finder__treffer-text">' +
        '<strong>' + t.name + '</strong>' +
        '<span>' + t.ort + '</span>' +
        '<span class="inlei-finder__entfernung">' +
        (t.km === null ? 'Entfernung auf Anfrage' : gerundet(t.km)) +
        '</span></div>';
      kanaeleSetzen();
    }

    function nachricht(anlass) {
      const t = gewaehlterTrainer;
      const anrede = t ? 'Hallo ' + (t.vorname || t.name) + ',' : 'Hallo InLei-Team,';
      const zeilen = [
        anrede,
        '',
        anlass === 'beratung'
          ? 'ich hätte gern ein kostenloses Beratungsgespräch zur InLei® Schulung.'
          : 'ich möchte einen Schulungsplatz sichern.',
        '',
        '· Bereich: ' + (BEREICH_TEXT[antwort.bereich] || '—'),
        antwort.erfahrung === 'entfaellt'
          ? null
          : '· Erfahrung: ' + (ERFAHRUNG_TEXT[antwort.erfahrung] || '—'),
        '· Postleitzahl: ' + antwort.land + ' ' + antwort.plz,
        antwort.set === 'entfaellt' ? null : '· Starterset: ' + (antwort.set === 'mit' ? 'ja, mit Starterset' : 'ohne Starterset'),
        '· Wunschzeitraum: ' + (ZEITRAUM_TEXT[antwort.zeitraum] || '—'),
        // Ohne diese Zeile kam die Anfrage beim Trainer ohne jeden Preisstand
        // an, waehrend die Interessentin einen eigenen im Kopf hatte.
        '· Preis laut Website: ' + rechnung(antwort, preise).kurz,
        '',
        'Meine Kontaktdaten:',
        '· Name: ' + (antwort.name || '—'),
        '· E-Mail: ' + (antwort.mail || '—'),
        '· Telefon: ' + (antwort.telefon || '—'),
        antwort.hinweis ? '' : null,
        antwort.hinweis ? 'Mein Hinweis: ' + antwort.hinweis : null,
        '',
        'Viele Grüße',
        antwort.name || ''
      ];
      // null steht fuer "Zeile entfaellt" — ohne das Aussortieren bliebe an
      // ihrer Stelle eine Leerzeile stehen.
      return zeilen.filter((zeile) => zeile !== null).join('\n').trim();
    }

    function kanaeleSetzen() {
      preisblockZeichnen();
      const t = gewaehlterTrainer;
      const anlass = finder.querySelector('[data-finder-anlass][aria-pressed="true"]');
      const art = anlass ? anlass.dataset.finderAnlass : 'platz';
      const text = nachricht(art);

      const tel = finder.querySelector('[data-finder-kanal="telefon"]');
      const wa = finder.querySelector('[data-finder-kanal="whatsapp"]');
      const mail = finder.querySelector('[data-finder-kanal="mail"]');

      if (tel) {
        tel.hidden = !(t && t.telefon);
        if (t && t.telefon) tel.href = 'tel:' + t.telefon.replace(/[^\d+]/g, '');
      }
      if (wa) {
        wa.hidden = !(t && t.whatsapp);
        if (t && t.whatsapp) {
          wa.href =
            'https://wa.me/' + t.whatsapp.replace(/\D/g, '') + '?text=' + encodeURIComponent(text);
        }
      }
      if (mail) {
        mail.hidden = !(t && t.mail);
        if (t && t.mail) {
          const betreff =
            art === 'beratung' ? 'Beratung zur InLei® Schulung' : 'Schulungsplatz sichern';
          mail.href =
            'mailto:' + t.mail + '?subject=' + encodeURIComponent(betreff) +
            '&body=' + encodeURIComponent(text);
        }
      }
    }

    /* Eine stille Kopie jeder Anfrage an den Shop ist mit Shopifys
       eigenem Kontaktformular nicht möglich: Der Shop weist per Skript
       abgeschickte Formulare mit HTTP 403 ab, und ein echtes, unsichtbar
       mitgerendertes Formular fängt das Schutzskript beim Absenden ab.
       Beides am 2026-09-10 gemessen. Wer die Kopie braucht, braucht einen
       Formular-Dienst ausserhalb von Shopify — oder nimmt die Blindkopie
       im mailto-Link in Kauf, die dann aber nur beim Kanal E-Mail greift
       und im Mailprogramm des Interessenten sichtbar ist. */
    /* Kopie der Anfrage in die Google-Tabelle des Shops.

       Warum nicht über Shopifys eigenes Kontaktformular: Der Shop weist per
       Skript abgeschickte Formulare mit HTTP 403 ab, und ein unsichtbar
       mitgerendertes echtes Formular fängt sein Schutzskript beim Absenden
       ab (beides am 2026-09-10 gemessen). Google-Formulare nehmen Einträge
       dagegen an — und im Gegensatz zu einer Blindkopie im mailto-Link
       greift das bei allen drei Kanälen, auch bei WhatsApp und Anruf.

       Die Feldnummern stammen aus dem Formular "Schulungsfinder Anfragen".
       Wird das Formular neu angelegt, ändern sie sich und müssen hier nach. */
    const FELD = {
      name: 'entry.1090590998',
      mail: 'entry.1953366438',
      telefon: 'entry.134511374',
      plz: 'entry.612293364',
      bereich: 'entry.1510658567',
      trainer: 'entry.1321420598',
      kanal: 'entry.1258425571',
      hinweis: 'entry.1682559044'
    };
    const KANAL_TEXT = { telefon: 'Anruf', whatsapp: 'WhatsApp', mail: 'E-Mail' };

    let kopieGesendet = false;
    function kopieSenden(kanal) {
      if (kopieGesendet) return;
      kopieGesendet = true;
      const t = gewaehlterTrainer;
      const anlass = finder.querySelector('[data-finder-anlass][aria-pressed="true"]');
      const art = anlass && anlass.dataset.finderAnlass === 'beratung' ? 'Beratung' : 'Schulungsplatz';

      /* Messung: Ereignis für den Tag Manager (Conversion "Schulungsanfrage").
         Läuft unabhängig von der Tabellen-Kopie unten und einmal je Besuch.
         Es werden bewusst keine Kontaktdaten übergeben, nur Kanal und Anlass. */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'schulung_anfrage',
        anfrage_kanal: KANAL_TEXT[kanal] || kanal,
        anfrage_art: art,
        anfrage_land: antwort.land || ''
      });

      const ziel = finder.dataset.formularUrl;
      if (!ziel) return;
      const daten = new FormData();
      daten.append(FELD.name, antwort.name || '');
      daten.append(FELD.mail, antwort.mail || '');
      daten.append(FELD.telefon, antwort.telefon || '');
      daten.append(FELD.plz, antwort.land + ' ' + antwort.plz);
      daten.append(
        FELD.bereich,
        (BEREICH_TEXT[antwort.bereich] || '—') +
          (antwort.set === 'mit' ? ' · mit Starterset' : '') +
          (antwort.set === 'ohne' ? ' · ohne Starterset' : '') +
          ' · ' + (ZEITRAUM_TEXT[antwort.zeitraum] || '—') +
          ' · ' + art +
          ' · ' + rechnung(antwort, preise).kurz
      );
      daten.append(FELD.trainer, t ? t.name + ', ' + t.ort : '—');
      daten.append(FELD.kanal, KANAL_TEXT[kanal] || kanal);
      daten.append(FELD.hinweis, antwort.hinweis || '');
      try {
        // no-cors: Google antwortet ohne CORS-Kopfzeilen. Die Antwort ist
        // damit nicht lesbar, der Eintrag wird aber angelegt.
        fetch(ziel, { method: 'POST', body: daten, mode: 'no-cors', keepalive: true }).catch(() => {});
      } catch (e) {
        /* Der Interessent soll davon nichts merken — seine Nachricht an den
           Trainer geht in jedem Fall raus. */
      }
    }

    /* ---------- Bedienung ---------- */
    finder.addEventListener('click', (ereignis) => {
      const kanalKnopf = ereignis.target.closest('[data-finder-kanal]');
      if (kanalKnopf) kopieSenden(kanalKnopf.dataset.finderKanal);


      const wahl = ereignis.target.closest('[data-finder-wahl]');
      if (wahl) {
        const feld = wahl.dataset.finderWahl;
        const wert = wahl.dataset.finderWert;
        antwort[feld] = wert;
        // Nach dem Wert markieren, nicht nach dem angeklickten Knopf: die
        // Starterset-Wahl steht an zwei Stellen (Schritt 4 und Ergebnis) und
        // soll dort immer denselben Stand zeigen.
        finder
          .querySelectorAll('[data-finder-wahl="' + feld + '"]')
          .forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.finderWert === wert)));
        let naechster = wahl.dataset.finderNaechster;
        // Wer ein Perfektionstraining sucht, arbeitet bereits mit Liftings —
        // die Frage nach der Erfahrung waere dort sinnlos.
        if (feld === 'bereich' && wert === 'perfektion') {
          antwort.erfahrung = 'entfaellt';
          naechster = 'plz';
        }
        if (naechster === 'ergebnis') {
          ergebnisBauen();
          weiter('ergebnis');
        } else if (naechster) {
          weiter(naechster);
        } else {
          kanaeleSetzen();
        }
        return;
      }

      const anlass = ereignis.target.closest('[data-finder-anlass]');
      if (anlass) {
        finder
          .querySelectorAll('[data-finder-anlass]')
          .forEach((b) => b.setAttribute('aria-pressed', String(b === anlass)));
        kanaeleSetzen();
        return;
      }

      if (ereignis.target.closest('[data-finder-plz-weiter]')) {
        // Auf die Tabelle warten, falls sie noch unterwegs ist — sonst
        // rechnet der erste Besucher mit der groben Rueckfall-Tabelle.
        tabelleLaden(finder.dataset.plzQuelle).then(() => {
          const ort = ortAusPlz(landFeld.value, plzFeld.value);
          if (!ort) {
            plzFehler.hidden = false;
            plzFeld.focus();
            return;
          }
          plzFehler.hidden = true;
          antwort.land = landFeld.value;
          antwort.plz = plzFeld.value.replace(/\D/g, '');
          // Das Perfektionstraining wird ohne Starterset angeboten — die
          // Frage danach waere dort irrefuehrend und wird uebersprungen.
          if (antwort.bereich === 'perfektion') {
            antwort.set = 'entfaellt';
            weiter('zeitraum');
          } else {
            weiter('set');
          }
        });
        return;
      }

      if (ereignis.target.closest('[data-finder-kontakt-weiter]')) {
        const name = (nameFeld.value || '').trim();
        const mail = (mailFeld.value || '').trim();
        const telefon = (telFeld.value || '').trim();
        // Ohne Namen und ohne einen Rueckweg kann der Trainer nicht
        // antworten — genau dafuer steht dieser Schritt hier.
        const mailOk = mail === '' || /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail);
        if (!name || (!mail && !telefon) || !mailOk) {
          kontaktFehler.hidden = false;
          kontaktFehler.textContent = !name
            ? 'Bitte trag deinen Namen ein.'
            : !mailOk
              ? 'Diese E-Mail-Adresse sieht nicht vollständig aus.'
              : 'Bitte gib eine E-Mail-Adresse oder eine Telefonnummer an, damit dein Trainer antworten kann.';
          (!name ? nameFeld : !mailOk ? mailFeld : mailFeld).focus();
          return;
        }
        kontaktFehler.hidden = true;
        antwort.name = name;
        antwort.mail = mail;
        antwort.telefon = telefon;
        antwort.hinweis = (hinweisFeld.value || '').trim();
        ergebnisBauen();
        weiter('ergebnis');
        return;
      }

      const mehr = ereignis.target.closest('[data-finder-mehr]');
      if (mehr) {
        const offen = liste.hidden;
        liste.hidden = !offen;
        mehr.setAttribute('aria-expanded', String(offen));
        return;
      }

      if (ereignis.target.closest('[data-finder-zurueck]')) {
        const vorher = verlauf.pop();
        if (vorher) zeige(vorher);
        return;
      }

      // Klick neben das Panel schliesst ebenfalls.
      if (ereignis.target.closest('[data-finder-zu]') || ereignis.target === finder) {
        schliessen();
      }
    });

    plzFeld.addEventListener('input', () => {
      plzFehler.hidden = true;
    });
    plzFeld.addEventListener('keydown', (ereignis) => {
      if (ereignis.key === 'Enter') {
        ereignis.preventDefault();
        finder.querySelector('[data-finder-plz-weiter]').click();
      }
    });

    [nameFeld, mailFeld, telFeld].forEach((feld) => {
      if (!feld) return;
      feld.addEventListener('input', () => {
        kontaktFehler.hidden = true;
      });
      feld.addEventListener('keydown', (ereignis) => {
        if (ereignis.key === 'Enter') {
          ereignis.preventDefault();
          finder.querySelector('[data-finder-kontakt-weiter]').click();
        }
      });
    });

    function oeffnen(ausloeser) {
      letzterOeffner = ausloeser || null;
      tabelleLaden(finder.dataset.plzQuelle);
      verlauf = [];
      zeige('bereich');
      finder.classList.add('is-offen');
      document.documentElement.classList.add('inlei-finder-offen');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', beiTaste);
    }

    function schliessen() {
      finder.classList.remove('is-offen');
      document.documentElement.classList.remove('inlei-finder-offen');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', beiTaste);
      if (letzterOeffner && document.contains(letzterOeffner)) letzterOeffner.focus();
    }

    function beiTaste(ereignis) {
      if (ereignis.key === 'Escape') schliessen();
    }

    // Jeder Knopf mit data-inlei-finder-open oeffnet das Panel — auch der
    // in der Leiste am unteren Rand.
    document.addEventListener('click', (ereignis) => {
      const ausloeser = ereignis.target.closest('[data-inlei-finder-open]');
      if (!ausloeser) return;
      ereignis.preventDefault();
      oeffnen(ausloeser);
    });

    zeige('bereich');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (ereignis) => init(ereignis.target));
})();

